import { Conversation as DefaultConversation } from 'components';
import styled from 'styled-components';

export const Conversation = styled(DefaultConversation)``;

export const ConversationsContent = styled.div``;
